import { Controller } from "@hotwired/stimulus";
import { navigator } from "@hotwired/turbo";

export default class extends Controller {
  static targets = ["submit"];
  static classes = ["busy"];
  static values = {
    busyText: String,
    initValidate: {
      type: Boolean,
      default: true,
    },
  };

  readonly submitTarget: HTMLButtonElement;
  readonly hasSubmitTarget: boolean;
  readonly hasBusyClass: boolean;
  readonly submitTargets: HTMLElement[];
  readonly busyClass: string;
  readonly busyTextValue: string;
  readonly initValidateValue: boolean;
  boundSubmitEnd: EventListener;

  connect() {
    if (this.initValidateValue) this.validate();

    this.boundSubmitEnd = this.submitEnd.bind(this);
    document.addEventListener("turbo:submit-end", this.boundSubmitEnd);
  }

  disconnect() {
    document.removeEventListener("turbo:submit-end", this.boundSubmitEnd);
  }

  disableSubmit() {
    if (this.hasSubmitTarget) {
      this.submitTargets.forEach((submit: HTMLButtonElement) => {
        if (submit.dataset.formIdleText === undefined)
          submit.dataset.formIdleText = submit.innerHTML;
        submit.disabled = true;
        if (this.hasBusyClass) submit.classList.add(this.busyClass);
        submit.innerHTML = this.busySubmitText;
      });
    }
  }

  enableSubmit() {
    if (this.hasSubmitTarget) {
      this.submitTargets.forEach((submit: HTMLButtonElement) => {
        submit.disabled = false;
        if (this.hasBusyClass) submit.classList.remove(this.busyClass);
        if (submit.dataset.formIdleText !== undefined)
          submit.innerHTML = submit.dataset.formIdleText;
      });
    }
  }

  submitEnd(event: CustomEvent) {
    if (event.target !== this.element) return;

    this.enableSubmit();
  }

  submitInvalid() {
    this.element.setAttribute("novalidate", "");
  }

  submit() {
    navigator.submitForm(this.element as HTMLFormElement);
  }

  validate() {
    if (this.hasSubmitTarget) {
      this.submitTargets.forEach((submit: HTMLButtonElement) => {
        submit.disabled = !this.isValid;

        if (this.hasBusyClass) submit.classList.remove(this.busyClass);
      });
    }
  }

  get isValid() {
    return !this.hasInvalidInputs();
  }

  // Default busy state shows the spinner only (rendered by the `.busy:disabled::after` CSS);
  // a form may opt into busy text by setting `data-form-busy-text-value`.
  get busySubmitText(): string {
    return this.busyTextValue;
  }

  hasInvalidInputs(): boolean {
    return this.element.querySelector("input:invalid:not([disabled])") != null;
  }
}
